// Bumping this string marks the handbook as "new" until the user opens it.
// Increment whenever you meaningfully update handbook content.
export const HANDBOOK_VERSION = "2026-02-locations-tiers";

const KEY = "rostr.handbook.viewed";

export function isHandbookUnread() {
  try {
    return localStorage.getItem(KEY) !== HANDBOOK_VERSION;
  } catch {
    return false;
  }
}

export function markHandbookViewed() {
  try {
    localStorage.setItem(KEY, HANDBOOK_VERSION);
    // Notify listeners in the same tab (storage events only fire cross-tab)
    window.dispatchEvent(new Event("rostr:handbook-viewed"));
  } catch { /* ignore */ }
}
